const icon = require('vue-svgicon');
icon.register({
    'warning': {
        width: 18,
        height: 17,
        viewBox: '0 0 18 17',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 .222L.111 16.89H17.89L9 .222zm0 1.786l7.11 13.69H1.89l7.11-13.69zm-.592 11.905v-1.191h1.185v1.19H8.408zm0-2.977c0 .329.265.595.592.595a.594.594 0 00.593-.595V6.77a.593.593 0 10-1.185 0v4.166z" _fill="#C70E00"/>`,
    },
});
